import { useEffect, useRef } from "react";
import styles from "./styles.module.scss";

function VideoComponent({ track }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (track && videoRef.current) {
      track.attach(videoRef.current);
    }

    return () => {
      if (track && videoRef.current) {
        track.detach(videoRef.current);
      }
    };
  }, [track]);

  if (!track) return null;

  return (
      <video
        ref={videoRef}
        /* id={track.sid} */
        autoPlay
        playsInline
        muted={track.isMuted}
        className={styles.video}
      />
  );
}

export default VideoComponent;
